import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL ;
// const SOCKET_URL = 'https://test.profita.in';
// const SOCKET_URL = 'https://profita.in';
// const SOCKET_URL = 'http://103.160.107.119:5000';
// or whatever variable you already use for your API URL


export const socket = io(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket'],
});

export default socket;